export const articleLinks = () => {
  const $sections = document.querySelectorAll(".article-links");

  $sections.forEach(($section) => {
    const $cards = $section.querySelectorAll("[data-ref='article-links-card']");

    $cards.forEach(($card) => {
      const $header = $card.querySelector("[data-ref='article-links-header']");
      const $body = $card.querySelector("[data-ref='article-links-body']");
      const $chevron = $card.querySelector("[data-ref='article-links-chevron']");

      $header.addEventListener("click", () => {
        const isOpen = !$body.classList.contains("hidden");
        $body.classList.toggle("hidden", isOpen);
        $chevron.classList.toggle("hidden", !isOpen);
        $header.setAttribute("aria-expanded", (!isOpen).toString());
      });
    });
  });
};

export default articleLinks;
